import { buildModelManager } from "../builder.js";
const DefaultHolidayCacheSelection = {
  __typename: true,
  id: true,
  calendarId: true,
  countryCode: true,
  countryName: true,
  createdAt: true,
  errorMessage: true,
  fetchStatus: true,
  holidays: true,
  lastFetchedAt: true,
  updatedAt: true,
  year: true
};
const modelApiIdentifier = "holidayCache";
const pluralModelApiIdentifier = "holidayCaches";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultHolidayCacheSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultHolidayCacheSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultHolidayCacheSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultHolidayCacheSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultHolidayCacheSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultHolidayCacheSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultHolidayCacheSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createHolidayCache",
    operationReturnType: "CreateHolidayCache",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      holidayCache: { required: false, type: "CreateHolidayCacheInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultHolidayCacheSelection
  },
  {
    type: "action",
    operationName: "bulkCreateHolidayCaches",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateHolidayCachesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultHolidayCacheSelection
  },
  {
    type: "action",
    operationName: "updateHolidayCache",
    operationReturnType: "UpdateHolidayCache",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      holidayCache: { required: false, type: "UpdateHolidayCacheInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultHolidayCacheSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateHolidayCaches",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateHolidayCachesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultHolidayCacheSelection
  },
  {
    type: "action",
    operationName: "deleteHolidayCache",
    operationReturnType: "DeleteHolidayCache",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteHolidayCaches",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertHolidayCache",
    operationReturnType: "UpsertHolidayCache",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      holidayCache: { required: false, type: "UpsertHolidayCacheInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateHolidayCacheResult": { hasReturnType: false },
      "... on UpdateHolidayCacheResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultHolidayCacheSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertHolidayCaches",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertHolidayCachesInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultHolidayCacheSelection
  }
];
const HolidayCacheManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultHolidayCacheSelection,
  operations
);
export {
  DefaultHolidayCacheSelection,
  HolidayCacheManager
};
//# sourceMappingURL=HolidayCache.js.map
